import { z } from "zod";

export const getPartnershipTimelineQuerySchema = z.object({
	week: z.string().regex(/^\d{4}-\d{2}$/),
});

export type GetPartnershipTimelineQuery = z.infer<typeof getPartnershipTimelineQuerySchema>;
